import script from "./AppDisclaimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDisclaimer.vue?vue&type=script&setup=true&lang=ts"

import "./AppDisclaimer.vue?vue&type=style&index=0&id=44a44130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a44130"]])

export default __exports__